import React from "react";
import "../../assets/styles/welcome.css";

export default class Welcome extends React.Component {
  componentDidMount() {
    this.props.onSetSource();
  }

  render() {
    return (
      <section className="welcome-wrapper color-n bg-a">
        <div className="page-center">
          <div className="steps">
            <div className="step">
              <div className="step-detail">
                <div className="space">
                  <img src={"themes/" + window.provider + "/images/process_1.png"} alt="" />
                  <img className="process-line" src={"themes/" + window.provider + "/images/process_line.png"} alt="" />
                </div>
                <div className="f3">מזדהים</div>
              </div>
              <div className="img-step">
                <img src={"themes/" + window.provider + "/images/icon_process_1.png"} alt="" />
              </div>
            </div>
            <div className="step">
              <div className="step-detail">
                <div className="space">
                  <img src={"themes/" + window.provider + "/images/process_2.png"} alt="" />
                  <img className="process-line" src={"themes/" + window.provider + "/images/process_line.png"} alt="" />
                </div>
                <div className="f3">בוחרים כרטיס</div>
              </div>
              <div className="img-step">
                <img src={"themes/" + window.provider + "/images/icon_process_2.png"} alt="" />
              </div>
            </div>
            <div className="step">
              <div className="step-detail">
                <div className="space">
                  <img src={"themes/" + window.provider + "/images/process_3.png"} alt="" />
                </div>
                <div className="f3">
                  <div>מקבלים קוד סודי</div>
                </div>
              </div>
              <div className="img-step">
                <img src={"themes/" + window.provider + "/images/code_asterisk.png"} alt="" />
              </div>
            </div>
            <div className="btn-wrapper clearfix">
              <button className="btn btn-lg bg-d f3" type="button" onClick={this.props.onNext}>
                כניסה <span className="sr-only"> לקבלת השירות</span>
              </button>
              <img src={"themes/" + window.provider + "/images/Secured.svg"} alt="" />
            </div>
          </div>

          <div className="disclaimer f7" aria-hidden="true">
            * השירות ניתן למחזיקי כרטיס שהונפק ישירות על ידי כאל וללקוחות הבנקים המשתתפים
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/Welcome.jsx